const validAnswers = {
  'b6357b78-776c-4e3d-b0e9-b8e84a606f94': ['B'], // 1                   Skąd instytucje w Polsce czerpią...
  '316e4e58-1ab1-472c-8812-e3d0d8ad6e2d': ['A'], // 2                   Czy stopa bezrobocia wpływa na...
  '8f1e3b68-1535-4002-9f73-b8dfa4ddddc3': ['B'], // 3                   Spadek stóp procentowych ma ...
  '721aab31-d09c-4815-ba4e-99de5f89d891': ['C'], // 4                   Kiedy zalecana jest nadpłata ...
  '453d8c50-63ab-4d91-8c1f-0da492992cae': ['A'], // 5                   Słynny Czarny Czwartek, rozpoczynający...
  'c33ee305-c468-48a5-8f47-d71c0de3b582': ['D'], // 6                   Pierwszy internetowy serwis wymiany walut...
  '75642b50-b33c-440f-b794-3d05349c37ee': ['A'], // 7                   Na rynku FOREX, najwięcej transkacji (87%)...
  '5ec19679-b68c-4e0c-92c2-67f913d18b13': ['C'], // 8                   NOK to waluta...?
  '38f043a4-ebc2-476b-b0c3-00cebebc4781': ['B'], // 9                   Spread to różnica między kursem NBP a ...
  '69642b3d-2969-47c7-a72f-b72832aecaeb': ['D'], // 10                  Na banknocie 100 zł widnieje:
  'd256e4e5-80f5-42e6-96ca-bc11a8483702': ['C'], // 11                  Ile państw jest członkami Banku Światowego?
  '72cb0c2a-17b7-4ada-b846-00985d3e1cf0': ['B'], // 12                  W którym roku polski złoty zastąpiła markę ...
  'f09e97c7-e355-4067-bca6-47d9b18de3f5': ['C'], // 13                  Symbol starego złotego sprzed denominacji to:
  '10733794-ad7b-4041-818a-0ef69d1d1219': ['A'], // 14                  W jakich walutach realizowane są przelewy SEPA
  '09a0f788-8523-4e13-9ceb-05c3b8503c48': ['C'], // 15                  „Pracować na rzecz świata wolnego od ubóstwa” ...
  '4df50a5f-83fe-45f9-940e-07926b44563f': ['A'], // 16                  Ustawa antyspreadowa z 2011 roku pozwoliła na:
  '23bcd0eb-4597-4b6c-97e0-54c7deb0cc12': ['D'], // 17                  Oszczędności na czarną godzinę nazywane są ...
  '11dd5595-6d50-4744-b58e-334c28bbd44b': ['C'], // 18                  Inflacja w Polsce w marcu 2021 roku, wg GUS ...
  'f9fdc01d-995b-4a36-87a9-04eb05a821b9': ['D'], // 19                  Wartość codziennych transakcji na światowej ...
  'ddd06cc9-db01-47bc-9d28-fe6e7ee87b3f': ['D'], // 20                  Króta z tych walut NIE jest uważana za ...
  'ee0d38a7-966a-4435-9407-e757e90819dd': ['A'], // 21                   "Słaba waluta na chwilę będzie wsparciem ...
  '5ed13acf-2bb3-4b8b-ad91-eb52da9c34e0': ['A'], // 22                  Co to jest dochód pasywny?
  'd59df0f3-714a-4774-b10e-c8c63f3363d3': ['A', 'B', 'C', 'D'], // 23   Rola NBP to (możesz zaznaczyć wiele):
  '5249fc28-36e4-467a-bb21-310759b52524': ['D'], // 24                  Co NIE jest odczytem makroekonomicznym?
  '7aff8551-3a98-49d3-8f5d-61862db50861': ['D'], // 25                  Jakie wydarzenie NIE miało większego wpływu...
  '8f5f1d81-47a6-4d4a-8bb6-92211969de00': ['B'], // 26                  Czy w Banku Światowym mozna założyc konto i...
  '308a1fb3-68e8-4c00-8af3-e905eecc2d80': ['A'], // 27                  Jakim terminem określa się nieoczekiwane ...
  '3dadc127-f7c4-474a-9401-2de2819330e3': ['A'], // 28                  Działalność takich agencji informacyjnych ...
  'b58d1934-2331-49ed-95bd-ec430fb5151e': ['A'], // 29                  Dotychczas za safe haven uznaje sie waluty ...
  'ab6ebc7d-6b8f-464c-bacd-9fad8953c6d3': ['B'], // 30                  Kryzys z 2008 roku był spowodowany udzielani...
  '8e667eb4-4c66-4268-b4e4-d56797df4248': ['B'], // 31                  Dla „złotówkowych” kredytów, rolę stopy refer...
  '5fae4d83-f620-433d-b73d-12bb5ef375e7': ['A'], // 32                  Dot-com boom to okres fascynacji branżami...
}

const greenColor = '#138500'
const redColor = '#d11c1c'

const initStart = (): void => {
  const $allElements = document.querySelectorAll<HTMLElement>('[data-poll-step]')
  $allElements.forEach((element) => {
    const $currentButton = element.querySelector<HTMLButtonElement>('[data-submit]')

    if ($currentButton) {
      $currentButton.addEventListener('click', goNext)
    }

    const $currentInput = element.querySelectorAll<HTMLInputElement>('input[id]')
    $currentInput.forEach((input) => {
      const isCheckbox = input.type === 'checkbox'

      if (isCheckbox) {
        input.addEventListener('click', () => {
          const checkedInput = element.querySelectorAll<HTMLInputElement>('input[type="checkbox"]:checked').length
          checkedInput > 0 ? ($currentButton.disabled = false) : ($currentButton.disabled = true)
        })
      } else {
        input.addEventListener('click', () => {
          $currentButton.disabled = false
        })
      }
    })
  })

  const $endButton = document.querySelector<HTMLButtonElement>('[end-quiz]')
  $endButton.addEventListener('click', onEndButton)
}

const goNext = (event: Event): void => {
  const $currentButtonStep = event.currentTarget as HTMLButtonElement
  const stepNumber = $currentButtonStep.dataset.shouldStepTo
  const $allToHide = document.querySelectorAll<HTMLElement>('[data-poll-step]')

  $allToHide.forEach((element) => {
    element.hidden = true
  })

  const $nextQuestion = document.querySelector<HTMLElement>(`[data-poll-step='${stepNumber}']`)
  $nextQuestion.hidden = false
}

const onEndButton = (): void => {
  createObjectWithAnswers()
  countScore(answersObject, scoreFromCheckbox)
  endQuiz()
}

interface TypeAnswersObject {
  questionId?: string
  answer?: string
}

const answersObject: TypeAnswersObject = {}
let scoreFromCheckbox = 0

const createObjectWithAnswers = (): void => {
  const $buttons = document.querySelectorAll<HTMLElement>('[data-question]')
  $buttons.forEach((element) => {
    const questionId = element.getAttribute('data-question')
    const $checkedRadioButton = element.querySelector<HTMLInputElement>('input[type=radio]:checked')
    if ($checkedRadioButton !== null) {
      answersObject[questionId] = [$checkedRadioButton.value]
    } else {
      scoreFromCheckbox = element.querySelectorAll<HTMLInputElement>('input[type=checkbox]:checked').length
    }
  })
}

const countScore = (answersObject: TypeAnswersObject, scoreFromCheckbox: number): void => {
  const responseResults = Object.keys(answersObject).map(
    (key) => JSON.stringify(answersObject[key]) === JSON.stringify(validAnswers[key]),
  )

  const score = responseResults.filter(Boolean).length + scoreFromCheckbox

  const $points = document.querySelector<HTMLElement>('[data-scored-points]')
  $points.textContent = score.toString()
}

const endQuiz = (): void => {
  deleteElements()
  showQuestions()
  showCorrectAnswers()
  showWrongAnswers()
}

const deleteElements = (): void => {
  const $startElement = document.querySelector<HTMLElement>('[data-poll-step]')
  const $buttonsToDelete = document.querySelectorAll<HTMLElement>('[data-submit]')
  $startElement.remove()
  $buttonsToDelete.forEach((button) => {
    button.remove()
  })
}

const showQuestions = (): void => {
  const $allQuestions = document.querySelectorAll<HTMLElement>('[data-poll-step]')
  $allQuestions.forEach((question) => {
    const $inputs = question.querySelectorAll<HTMLInputElement>('[id]')
    $inputs.forEach((answer) => {
      answer.disabled = true
    })
    question.hidden = false
  })
}

const showCorrectAnswers = (): void => {
  Object.keys(validAnswers).map((key) => {
    const $data_question = document.querySelector<HTMLElement>(`[data-question='${key}']`)

    const isCheckbox = validAnswers[key].length > 1

    if (isCheckbox) {
      const $checkbox = document.querySelector<HTMLElement>(`[data-question='${key}']`)
      const $checkboxInput = $checkbox.querySelectorAll<HTMLInputElement>('input[type=checkbox]')
      $checkboxInput.forEach((element) => {
        element.classList.add('correct')
        const $label = document.querySelector<HTMLLabelElement>(`[for=${element.id}]`)
        $label.style.color = greenColor
      })
    } else {
      const $correctValue = $data_question.querySelector<HTMLInputElement>(`input[value='${validAnswers[key]}']`)
      const $answerText = document.querySelector<HTMLLabelElement>(`[for=${$correctValue.id}]`)
      $correctValue.classList.add('correct')
      $answerText.style.color = greenColor
    }
  })
}

const showWrongAnswers = (): void => {
  Object.keys(answersObject).map((key) => {
    const $data_question = document.querySelector<HTMLInputElement>(`[data-question='${key}']`)
    const $checkedInput = $data_question.querySelector<HTMLInputElement>('input[type=radio]:checked')
    const $answerText = document.querySelector<HTMLLabelElement>(`[for=${$checkedInput.id}]`)

    if (!$checkedInput.classList.contains('correct')) {
      $checkedInput.classList.add('invalid')
      $answerText.style.color = redColor
    }
  })
}

export default initStart
